<template>
  <ButtonWhite
    v-if="availableItems.length"
    class="!w-auto !px-3 !py-1 !rounded-md !shadow-sm shrink-0 self-center text-sm leading-5 disabled:cursor-wait disabled:opacity-60"
    :title="label"
    :disabled="isDownloading"
    data-testid="request-files-zip"
    @click="handleDownload"
  />
</template>

<script setup>
import { computed, ref } from 'vue';
import { toast } from 'vue3-toastify';
import { useI18n } from 'vue-i18n';
import ButtonWhite from '@/components/button/ButtonWhite.vue';
import { downloadRequestFilesZip, zipErrorMessage } from '@/services/requestFilesZip';

/**
 * «Descargar todo» o «Descargar seleccionados (n)» en un ZIP (ADSREC-0025),
 * según las casillas marcadas en la tabla de archivos de la solicitud.
 */
const props = defineProps({
  requestId: {
    type: [String, Number],
    required: true,
  },
  requestCode: {
    type: String,
    default: '',
  },
  items: {
    type: Array,
    default: () => [],
  },
  // El useRowSelection de la tabla, envuelto en reactive().
  selection: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();
const isDownloading = ref(false);

const availableItems = computed(() => props.items.filter((item) => item.is_available !== false));
const selectedItems = computed(() => (
  props.selection?.count ? availableItems.value.filter((item) => props.selection.isSelected(item)) : []
));

const label = computed(() => {
  if (isDownloading.value) return t('requestFiles.zip.downloading');

  return selectedItems.value.length
    ? t('requestFiles.zip.downloadSelected', { count: selectedItems.value.length })
    : t('requestFiles.zip.downloadAll');
});

const handleDownload = async () => {
  if (isDownloading.value) return;

  isDownloading.value = true;
  try {
    const ids = selectedItems.value.length ? selectedItems.value.map((item) => item.id) : null;
    await downloadRequestFilesZip(props.requestId, ids, props.requestCode);
  } catch (error) {
    console.error('Error downloading request files zip:', error);
    toast.error((await zipErrorMessage(error)) || t('requestFiles.zip.error'));
  } finally {
    isDownloading.value = false;
  }
};
</script>
